import React from 'react';
import { Select } from '../../../components/aa';
import type { SessionPurpose, SessionTargets } from '../../../types/aai';
import { PURPOSE_LABEL } from './sessionShared';

/*
 * What the session is for, picked before the agent drafts: a project or a
 * Quick Win of this client (then which one), general questions, or company
 * context. The agent reads it on every message.
 */

const PURPOSES: SessionPurpose[] = ['project', 'quick_win', 'general', 'context'];

export const needsTarget = (purpose: SessionPurpose): boolean => purpose === 'project' || purpose === 'quick_win';

export const PurposeBar: React.FC<{
  purpose: SessionPurpose;
  targetId: string;
  targets: SessionTargets | null;
  disabled: boolean;
  onChange: (purpose: SessionPurpose, targetId: string, targetTitle: string) => void;
}> = ({ purpose, targetId, targets, disabled, onChange }) => {
  let options: { id: string; title: string }[] = [];
  if (purpose === 'project') options = targets?.projects || [];
  if (purpose === 'quick_win') options = targets?.quick_wins || [];
  let placeholder = 'Loading…';
  if (targets && purpose === 'project') placeholder = 'Choose the project';
  if (targets && purpose === 'quick_win') placeholder = 'Choose the Quick Win';
  let empty = '';
  if (targets && purpose === 'project' && options.length === 0) empty = 'This client has no builder projects yet.';
  if (targets && purpose === 'quick_win' && options.length === 0) empty = 'This client has no Quick Wins yet.';

  const pickTarget = (id: string) => {
    const hit = options.find((o) => o.id === id);
    onChange(purpose, id, hit?.title || '');
  };

  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-line-soft bg-canvas px-4 py-2.5">
      <span className="text-[12px] font-semibold text-ink-muted">This session is for</span>
      <Select
        value={purpose}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as SessionPurpose, '', '')}
        aria-label="What this session is for"
        className="!h-9 !w-auto !py-0 !text-[12.5px] leading-none"
      >
        {PURPOSES.map((p) => <option key={p} value={p}>{PURPOSE_LABEL[p]}</option>)}
      </Select>
      {needsTarget(purpose) && options.length > 0 && (
        <Select
          value={targetId}
          disabled={disabled}
          onChange={(e) => pickTarget(e.target.value)}
          aria-label={placeholder}
          className="!h-9 !w-[260px] !max-w-full !py-0 !text-[12.5px] leading-none"
        >
          <option value="">{placeholder}</option>
          {options.map((o) => <option key={o.id} value={o.id}>{o.title}</option>)}
        </Select>
      )}
      {needsTarget(purpose) && !targets && <span className="text-[12px] text-ink-dim">{placeholder}</span>}
      {empty && <span className="text-[12px] text-ink-dim">{empty}</span>}
    </div>
  );
};

export default PurposeBar;
